var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeaderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 32,
    viewBox: "0 0 29 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3725 1.3103C20.7729 12.8828 12.6045 23.8117 6.38178 26.1235C0.31056 15.4682 1.59769 9.57634 11.3725 1.3103Z",
    fill: "#52B12F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3727 1.31036C1.59792 9.5764 0.310792 15.4682 6.38201 26.1236L11.3727 1.31036Z",
    fill: "#1B5C29"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7277 24.0862C22.6961 33.5442 13.1782 31.1932 9.90812 27.7206C15.2635 20.7228 19.5232 19.9274 27.7277 24.0862Z",
    fill: "#52B12F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7277 24.0864C19.5233 19.9276 15.2635 20.723 9.90814 27.7208L27.7277 24.0864Z",
    fill: "#1B5C29"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderIcon);
export default __webpack_public_path__ + "static/media/headerIcon.00c1a5cbe12b26c47f80f124017134e7.svg";
export { ForwardRef as ReactComponent };